module.exports = __webpack_public_path__ + "static/cfg-title-b0d7f5284de4a0b4c03eb6724839c225.png";